<template>
    <div>
        <div class="card-header">
            <div class="card-header">
                <div class="d-flex">
                    <div class="flex-fill">
                        <FamilyStatementConflictSearch></FamilyStatementConflictSearch>
                    </div>

                    <div class="float-end">
                        <FamilyStatementConflictPagination></FamilyStatementConflictPagination>
                    </div>

                </div>

            </div>

            <div class="card-body">
                <FamilyStatementConflictTable></FamilyStatementConflictTable>
            </div>
        </div>
    </div>
</template>
<script>
import FamilyStatementConflictSearch from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementConflictList/Family-statement-conflict-search.vue";
import FamilyStatementConflictTable from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementConflictList/Family-statement-conflict-table.vue";
import FamilyStatementConflictPagination from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementConflictList/Family-statement-conflict-pagination.vue";

export default {
    name: 'FamilyStatementConflictList',

    components:{
        FamilyStatementConflictTable,
        FamilyStatementConflictPagination,
        FamilyStatementConflictSearch
    }
}
</script>
<style></style>